//@flow
import BaseEntitySelectors from 'common/redux/selectors/BaseEntitySelectors';
import { createSelector } from 'reselect';

class SchedulingConfigSelectors extends BaseEntitySelectors {
    constructor() {
        super('schedulingConfig');
    }

    getSchedulingConfigForPjpCreation = createSelector(
        [this.getEntities],
        schedulingConfigs => {
            return (
                schedulingConfigs &&
                schedulingConfigs.entities.map(entity => {
                    return {
                        id: entity.id,
                        label: entity.name || entity.id,
                        description: entity.description
                    };
                })
            );
        }
    );

    getFirstSchedulingConfigId = createSelector(
        [this.getSchedulingConfigForPjpCreation],
        schedulingConfigs =>
            schedulingConfigs && schedulingConfigs[0] && schedulingConfigs[0].id
    );
}

export default new SchedulingConfigSelectors();
